<div class="form">
  <div *ngFor="let item of vm; index as i" class="filter-row">
    <mat-form-field [hidden]="i === 0 || onlyAndStatement">
      <mat-label>Statement</mat-label>
      <mat-select [(value)]="item.statement">
        <mat-option [value]="'AND'">AND</mat-option>
        <mat-option [value]="'OR'">OR</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Term</mat-label>
      <mat-select [(value)]="item.term">
        <mat-option value="any">Any</mat-option>
        <mat-option *ngFor="let term of terms" [value]="term.id">{{
          term.displayName
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field [hidden]="item.term === 'any'">
      <mat-label>Operator</mat-label>
      <mat-select [(value)]="item.operator" [disabled]="!item.term">
        <mat-option
          *ngFor="let option of operators | keyvalue"
          [value]="option.key"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="item.term">
      <mat-form-field>
        <mat-label>Value</mat-label>
        <ng-container *ngIf="termHasOptions(item.term); else textInput">
          <mat-select
            [value]="item.value"
            (selectionChange)="updateRowInputValue(i, $event.value)"
          >
            <mat-option
              *ngFor="let option of termGetOptions(item.term)"
              [value]="option"
              >{{ option }}</mat-option
            >
          </mat-select>
        </ng-container>
        <ng-template #textInput>
          <input
            matInput
            (change)="updateRowInputValue(i, $any($event.target).value)"
            (keypress)="onKeypressEvent($event)"
          />
        </ng-template>
      </mat-form-field>
    </ng-container>
    <div
      (click)="removeFilterRow(i)"
      class="remove-row"
      style="cursor: pointer"
      *ngIf="vm.length > 1 && item.term"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.2457 5.92925C15.5701 5.60478 15.5701 5.07872 15.2457 4.75425C14.9212 4.42978 14.3951 4.42978 14.0707 4.75425L9.99984 8.82508L5.929 4.75425C5.60454 4.42978 5.07847 4.42978 4.754 4.75425C4.42954 5.07872 4.42954 5.60478 4.754 5.92925L8.82484 10.0001L4.754 14.0709C4.42954 14.3954 4.42954 14.9214 4.754 15.2459C5.07847 15.5704 5.60454 15.5704 5.929 15.2459L9.99984 11.1751L14.0707 15.2459C14.3951 15.5704 14.9212 15.5704 15.2457 15.2459C15.5701 14.9214 15.5701 14.3954 15.2457 14.0709L11.1748 10.0001L15.2457 5.92925Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
  </div>
  <button class="add" (click)="addFilterRow()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H9V4C9 3.44772 9.44772 3 10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10Z"
        fill="#2DBBFC"
      />
    </svg>
    <span>add</span>
  </button>
</div>
